exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".reanalyze-comparison-container {\n  padding: 20px;\n  max-width: 1200px;\n  max-height: 80vh;\n  overflow: auto;\n}\n\nh2 {\n  margin-top: 0;\n}\n\n.action-buttons {\n  margin: 20px 0;\n}\n\n.action-buttons button {\n  margin-right: 10px;\n}\n\n.comparison-table {\n  margin: 20px 0;\n  overflow-x: auto;\n}\n\ntable {\n  width: 100%;\n  border-collapse: collapse;\n}\n\nth, td {\n  padding: 10px;\n  border: 1px solid #ddd;\n  text-align: left;\n}\n\nth {\n  background-color: #f5f5f5;\n  font-weight: bold;\n}\n\ntr.selected {\n  background-color: #e8f5e9;\n}\n\n.transaction-details {\n  font-size: 12px;\n}\n\n.transaction-details div {\n  margin: 5px 0;\n}\n\n.no-transaction {\n  color: #999;\n  font-style: italic;\n}\n\n.buttons-container {\n  margin-top: 20px;\n  text-align: right;\n}\n\n.cancel-button {\n  margin-right: 10px;\n}\n\n.btn-confirm-dialog {\n  background-color: #4CAF50;\n  color: white;\n}\n\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/entities/finance/reanalyze-comparison/reanalyze-comparison.component.css
// module id = 1959
// module chunks = 0